import { ToolPageShell } from '@/shared/seo'
import { NeskolkoStranitsPdfForm } from './NeskolkoStranitsPdfForm'

export function NeskolkoStranitsPdfPage() {
  return (
    <ToolPageShell utilityKey="n-up-pdf">
      <NeskolkoStranitsPdfForm />
    </ToolPageShell>
  )
}
